

















































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class PricingView extends Vue {
  public items: Common.ProductTour[] = new Array(0);
  public params: Common.ProductTourQuery = new Common.ProductTourQuery();
  public sortOptions: any = [{ value: 'displayOrder', text: '表示順' }];
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }  
}
